import React from 'react';

import {
    sendDesktopAnalyticsEvent,
    sendDesktopAnalyticsPerSession,
} from '@optimaxdev/analytics/desktop/lib/sendAnalyticsEvent/index';
import classNames from 'classnames';
import {InView} from 'react-intersection-observer';
import {connect} from 'react-redux';

import {useFeature} from 'components/feature';
import {CHECKOUT_DELIVERY_STEP} from 'constants/analytics/events/checkout';
import {PRIVACY_POLICY, TERMS_AND_CONDITIONS} from 'constants/cmsContent';
import {openPopupWithCMSBlock} from 'desktop/reducers/cmsPopup';
import {useIsOneStepAvailable} from 'hooks/useIsOneStepAvailable/useIsOneStepAvailable';

import {DeliveryFormTitle} from '../deliveryFormTitle/deliveryFormTitle';
import {NewsletterSubscriptionConnected} from '../newsletterSubscription/newsletterSubscription';
import {ShippingMethodsConnected} from '../shippingMethods/shippingMethods';

import s from './deliveryContentWrapper.scss';

export type PropsType = {
    openCmsPopup: (data: {cmsBlockName: string; checkoutStep: string}) => void;
};

/**
 * Delivery Content Wrapper for DeliveryForm
 */
export const DeliveryContentWrapper: React.FC<PropsType> = ({openCmsPopup}) => {
    const isFacelift = useFeature('dCheckoutFacelift');

    const {isOneStepAvailable} = useIsOneStepAvailable();

    const sendAnalyticsHandler = (inView: boolean) => {
        if (inView) {
            sendDesktopAnalyticsPerSession({
                event: CHECKOUT_DELIVERY_STEP,
                label: {message: 'Shipping Method - Visible'},
            });
        }
    };

    const openTermsOfUse = () => {
        openCmsPopup({checkoutStep: 'DELIVERY_STEP', cmsBlockName: TERMS_AND_CONDITIONS});

        sendDesktopAnalyticsEvent(CHECKOUT_DELIVERY_STEP, {
            message: 'Terms & Condition - opened',
        });
    };

    const openPrivacyPolicy = () => {
        openCmsPopup({checkoutStep: 'DELIVERY_STEP', cmsBlockName: PRIVACY_POLICY});

        sendDesktopAnalyticsEvent(CHECKOUT_DELIVERY_STEP, {message: 'Privacy Policy - opened'});
    };

    return (
        <InView
            aria-label="Shipping Method"
            className={classNames(s.shippingWrapper, {[s.oneStep]: isOneStepAvailable})}
            onChange={sendAnalyticsHandler}
            triggerOnce
        >
            {!isOneStepAvailable && (
                <NewsletterSubscriptionConnected
                    openPrivacyPolicy={openPrivacyPolicy}
                    openTermsOfUse={openTermsOfUse}
                />
            )}
            <DeliveryFormTitle
                className={classNames(s.shippingTitle, {[s.shippingTitleFacelift]: isFacelift})}
            >
                Shipping method
            </DeliveryFormTitle>
            <ShippingMethodsConnected />
        </InView>
    );
};

export const DeliveryContentWrapperConnected = connect(null, {openCmsPopup: openPopupWithCMSBlock})(
    DeliveryContentWrapper,
);
